var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.906242 0.5L0.5 0.891952L10.4583 10.5L10.8646 10.108L0.906242 0.5Z",
    fill: "#384250"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4583 0.500002L0.5 10.108L0.906242 10.5L10.8646 0.891954L10.4583 0.500002Z",
    fill: "#384250"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.906242 0.5L0.5 0.891952L10.4583 10.5L10.8646 10.108L0.906242 0.5Z",
    stroke: "#384250",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4583 0.500002L0.5 10.108L0.906242 10.5L10.8646 0.891954L10.4583 0.500002Z",
    stroke: "#384250",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.776fa1deacc5eb1ec1d8d9678fa3b3b3.svg";
export { ForwardRef as ReactComponent };